import { formatCurrency } from "@veorest/utils";
import { Pill } from "@veorest/ui";
import {
  clientStatusLabelKey,
  clientStatusPillVariant,
  formatShortDateTime,
  type PartnerClientOverviewRow,
} from "../../lib/partnerReports";
import { useI18n } from "../../i18n";

interface ClientCardRowProps {
  client: PartnerClientOverviewRow;
  onOpen: () => void;
}

/** Mobile clients list card (desktop uses ClientsTable). */
export function ClientCardRow({ client, onOpen }: ClientCardRowProps) {
  const { t } = useI18n();
  const initials = client.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
  const statusLabel = t(clientStatusLabelKey(client.tenant_status));
  return (
    <button
      type="button"
      onClick={onOpen}
      className="customer-list-row w-full"
    >
      {client.logo_url ? (
        <img
          src={client.logo_url}
          alt=""
          className="customer-list-row__avatar customer-list-row__avatar--photo"
        />
      ) : (
        <div className="customer-list-row__avatar" aria-hidden>
          {initials || "BZ"}
        </div>
      )}
      <div className="min-w-0 flex-1 text-start">
        <div className="customer-list-row__top">
          <p className="customer-list-row__name truncate">{client.name}</p>
          <Pill variant={clientStatusPillVariant(client.tenant_status)}>
            {statusLabel}
          </Pill>
          {client.active_orders_count > 0 ? (
            <span className="customer-list-orders-badge">
              {client.active_orders_count} {t("clients.openOrdersKpi")}
            </span>
          ) : null}
        </div>
        <p className="customer-list-row__meta truncate">
          {client.orders_count} {t("nav.orders")} · {client.completed_count}{" "}
          {t("clients.colCompleted")} ·{" "}
          {formatShortDateTime(client.last_order_at)}
        </p>
        {client.outstanding_pending > 0 ? (
          <p className="mt-1 text-xs font-bold text-[var(--danger,#dc2626)]">
            {t("clients.colOutstanding")}:{" "}
            {formatCurrency(client.outstanding_pending, client.currency)}
          </p>
        ) : null}
      </div>
    </button>
  );
}
